import React from 'react';
import '../assets/styles/Contact.scss';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import DownloadIcon from '@mui/icons-material/Download';

function Contact() {
  return (
    <div className="container" id="contact">
      <div className="contact-container">
        <div className="contact-header">
          <span className="contact-tag">{'// Get In Touch'}</span>
          <h1>Let's build something serious.</h1>
          <p className="contact-subtitle">
            Available for senior advisory, architecture reviews, and consulting engagements.
          </p>
        </div>

        <div className="contact-body">
          <div className="contact-details">
            <div className="contact-item">
              <EmailIcon className="contact-icon" />
              <span>me@ahmadgharib.com</span>
            </div>
            <div className="contact-item">
              <LocationOnIcon className="contact-icon" />
              <span>Berlin, Germany</span>
            </div>
            <div className="contact-item">
              <LinkedInIcon className="contact-icon" />
              <a href="https://www.linkedin.com/in/ahmadrgharib" target="_blank" rel="noreferrer">
                linkedin.com/in/ahmadrgharib
              </a>
            </div>
            <div className="contact-item">
              <svg className="contact-icon" viewBox="0 0 24 24" fill="currentColor" width="20" height="20" aria-hidden="true">
                <path d="M18.375 9.556c-1.64 0-2.916.96-3.455 2.373l-1.234-5.04H11.25v6.416c0 1.013-.82 1.834-1.833 1.834s-1.834-.821-1.834-1.834V6.889H5.147v5.416c0 2.17 1.76 3.929 3.93 3.929 2.169 0 3.928-1.76 3.928-3.93v-.906c.48 1.61 1.88 2.836 3.37 2.836 2.17 0 3.93-1.76 3.93-3.929 0-2.17-1.76-3.75-1.93-3.75zm0 5.512c-.96 0-1.75-.79-1.75-1.762 0-.973.79-1.762 1.75-1.762.96 0 1.75.789 1.75 1.762 0 .972-.79 1.762-1.75 1.762z" />
              </svg>
              <a href="https://www.upwork.com/freelancers/~012aecb8a29fb8b721" target="_blank" rel="noreferrer">
                Upwork Profile
              </a>
            </div>
          </div>

          <div className="contact-actions">
            <a
              href="mailto:me@ahmadgharib.com?subject=Professional Inquiry"
              className="contact-btn-primary"
            >
              Send Email
            </a>
            <a
              href="/Ahmad_Gharib_CV.pdf"
              download="Ahmad_Gharib_CV.pdf"
              className="contact-btn-secondary"
            >
              <DownloadIcon />
              Download CV
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
